import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=637af414&scoped=true"
import script from "./MyProjects.vue?vue&type=script&lang=js"
export * from "./MyProjects.vue?vue&type=script&lang=js"
import style0 from "./MyProjects.vue?vue&type=style&index=0&id=637af414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637af414",
  null
  
)

export default component.exports